<template>
    <website-page>
        <restauration-navigation></restauration-navigation>

        <div class="main-section overlay main-carousel">
            <b-carousel controls indicators class="dark" :interval="6000">
                <b-carousel-slide>
                    <e-img slot="img" src="img/backgrounds/menu-board-mc-donald.jpg" img-class="w-100" alt="Restaurant Mc Donald Menuboard"></e-img>
                </b-carousel-slide>
                <b-carousel-slide>
                    <e-img slot="img" src="img/backgrounds/menu-board-coq-frit.jpg" img-class="w-100" alt="Digital Menu Board Coq Frit"></e-img>
                </b-carousel-slide>
                <b-carousel-slide>
                    <e-img slot="img" src="img/backgrounds/menu-board-thai-express-2.jpg" img-class="w-100" alt="Digital Menuboard Thai Express"></e-img>
                </b-carousel-slide>
                <b-carousel-slide>
                    <e-img slot="img" src="img/backgrounds/menu-board-double-pizza.jpg" img-class="w-100" alt="Menuboard Double Pizza"></e-img>
                </b-carousel-slide>
                <b-carousel-slide>
                    <e-img slot="img" src="img/backgrounds/menu-board-thai-express.jpg" img-class="w-100" alt="Restaurant Thai Express Menu board "></e-img>
                </b-carousel-slide>
            </b-carousel>

            <b-container>
                <div class="blured darker">
                    <h1  v-tr>A Complete Solution for Restaurant Digital Signage|Une solution d'affichage numérique complète pour restaurants</h1>
                    <h2 class="subtitle" v-tr>Go 100% Cloud with Eye-In Digital Menu Boards|Partez 100% Cloud avec l'affichage numérique Eye-In</h2>

                    <p class="presentation" v-tr>
                        Eye-In Media's Cloud Signage Application for Restaurants enables you to manage anything that can be pushed on a screen from a central point and without efforts.|
                        L'application d'affichage numérique centralisée d'Eye-In Media, permet aux restaurants de gérer tout ce qui peut s'afficher sur un écran à partir d'un point central et sans efforts.
                    </p>
                </div>
                <b-row class="mt-5">
                    <b-col cols="6" md="4" xl="2" class="client">
                        <e-img src="img/clients-white/oreal_canada.png" alt="Client  Digital Signage Oreal Canada"></e-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <e-img src="img/clients-white/shriners.png" alt="Client  Digital Signage Hospital Shriners"></e-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <e-img src="img/clients-white/alexis-nihon.png" alt="Client  Digital Signage Alexis Nihon Shopping Center"></e-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <e-img src="img/clients-white/mc_donald.png" alt="Client  Digital Signage McDonald"></e-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <e-img src="img/clients-white/mc_cafe.png" alt="Client Digital Signage McCafé"></e-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <e-img src="img/clients-white/cegep_beauce_appalache.png" alt="Client Digital Cegep Beauce Appalache"></e-img>
                    </b-col>
                </b-row>

                <div class="mt-5">
                    <b-btn v-scroll-to="'#contact-us'" class="mr-2" variant="primary"><span v-tr>Contact Us|Contactez-nous</span></b-btn>
                    <b-btn v-if="!isMobileLayout" v-scroll-to="'#key-features'" variant="outline-light"><span v-tr>Discover Digital Menu Boards|Découvrez les menus numériques</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="key-features" class="page">
            <b-container class="text-center" :class="isMobileLayout ? 'text-center': ''">
                <h2 class="mb-5" v-tr>Digital Signage Key Features|Fonctionnalités Clés de l'affichage numérique</h2>
                <b-row>
                    <b-col cols="12" md="4">
                        <e-img fluid fluid-grow src="img/screenshots/menuboard-cho-express.png"></e-img>
                        <h3 class="small mt-3" v-tr>Digital Menuboards|Menus numérique</h3>
                        <p v-tr>
                            Manage your menu in one place and display on your Digital Menuboard.|
                            La gestion des menus est entièrement centralisé : gestion des prix, de l’inventaire des éléments du menu et des images.

                        </p>
                        <p v-tr>
                            TheFoodForce comes with a simple menuboard designer module that allows you to create engaging digital menus dynamically linked to your menu items.|
                            Le diffuseur ajuste automatiquement le contenu du menu en fonction du restaurant auquel il est assigné.
                        </p>
                    </b-col>
                    <b-col cols="12" md="4">
                        <e-img fluid fluid-grow src="img/screenshots/starbucks-status-panel.png"></e-img>
                        <h3 class="small mt-3" v-tr>Order Status Panel|Panneau de suivi des commandes</h3>
                        <p v-tr>
                            Always dreamed of showing the status of your orders on a screen like at McDonald’s?|
                            Le panneau de suivi des commandes « à la McDonalds » est une fonctionnalité restée longtemps réservées aux plus grosses chaînes de restauration.
                        </p>
                        <p v-tr>
                            Our digital signage comes with an integrated module that you can customize which pushes real-time order status to your screens.|
                            Avec notre solution d’affichage, l’intégration se fait en quelques clics et offre plusieurs options pour ajuster le style visuel à la bannière.
                        </p>
                    </b-col>
                    <b-col cols="12" md="4">
                        <e-img fluid fluid-grow src="img/screenshots/romanceboard-mccafe.png"></e-img>
                        <h3 class="small mt-3" v-tr>Advertising Display|Affichage publicitaire</h3>
                        <p v-tr>
                            Le but principal de l’affichage numérique est d’afficher du contenu informatif ou publicitaire.
                        </p>
                        <p v-tr>
                            Notre solution d’affichage permet de gérer et diffuser des publicités programmées à l’avance en fonction de l’établissement, l’heure de la journée avec gestion de la fréquence etc…
                        </p>
                    </b-col>
                </b-row>

                <div v-if="!isMobileLayout" class="mt-5 text-center">
                    <b-btn v-scroll-to="'#digital-menuboard'" variant="light"><span v-tr>Digital Menu Boards|Menus numériques</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="digital-menuboard" class="page inverted">
                <h3 class="text-center mb-5">
                    "<span v-tr>Wow I know exactly what to order|Wow je sais exactement quoi commander</span>"
                </h3>

                <b-carousel controls indicators class="dark" :interval="4000">
                    <b-carousel-slide>
                        <e-img slot="img" src="img/examples/menu-cho-express.jpg" img-class="img-fluid w-100 d-block"
                               alt="Cho Express Digital Menu Board with Eye-In Media"></e-img>
                        Cho Express Menu
                    </b-carousel-slide>
                    <b-carousel-slide>
                        <e-img slot="img" src="img/examples/menu-avril.jpg" img-class="img-fluid w-100 d-block"
                               alt="Avril Market Digital Menu Board with Eye-In Media"></e-img>
                        Avril Market Menu
                    </b-carousel-slide>
                    <b-carousel-slide>
                        <e-img slot="img" src="img/examples/menu-hopital-shriners.jpg" img-class="img-fluid w-100 d-block"
                               alt="Hospital Shriners Cafeteria Digital Menu Board with Eye-In Media"></e-img>
                        Hospital Shriners Menu
                    </b-carousel-slide>
                    <b-carousel-slide>
                        <e-img slot="img" src="img/examples/menu-tcby.jpg" img-class="img-fluid w-100 d-block"
                               alt="TCBY Digital Menu Board with Eye-In Media"></e-img>
                        TCBY Menu
                    </b-carousel-slide>
                    <b-carousel-slide>
                        <e-img slot="img" src="img/examples/menu-thai-express.jpg" img-class="img-fluid w-100 d-block"
                               alt="MTY Thai Express Restaurant Digital Menu Board with Eye-In Media"></e-img>
                        Thai Express Menu
                    </b-carousel-slide>
                </b-carousel>
            <b-container>

                <h5 class="text-center mt-5" v-tr>
                    Customers have to be “wowed” and be impressed when they order. They are expecting two major emotions: satisfying their appetite and cravings; and feeling good from being empowered with a pleasant experience. This fact is valid both in high-end places and in quick service restaurants.|
                    Les clients doivent être impressionnés lors de leur commande. Ils s'attendent à deux émotions majeures: satisfaire leur appétit et leurs envies; et se sentir bien d'être habilité à vivre une expérience agréable. Ce fait est valable aussi bien dans les endroits haut de gamme que dans les restaurants à service rapide.
                </h5>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" class="mt-5" v-scroll-to="'#professional-menus'" variant="outline-light"><span v-tr>Professional Menu Boards|Menus numériques profesionnels</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="professional-menus" class="page">
            <b-container>
                <h2 class="text-center mb-5" v-tr>Professional Menu Boards|Menus numériques profesionnels</h2>
                <b-row>
                    <b-col md="6">
                        <h3 class="small" v-tr>Digital Menus Carefully Designed by Eye-In|Menus numériques conçus sur mesure par Eye-In</h3>
                        <p class="text-justify" v-tr>
                            Today’s consumers expect novelty and enjoyment. You have to capture their attention while you can. If you miss that small window of opportunity, you may leave them feeling that their choices are limited and they may order something that may not satisfy them.|
                            Les consommateurs d’aujourd’hui attendent de la nouveauté et du plaisir. Vous devez capter leur attention tant que vous le pouvez. Si vous manquez cette petite fenêtre d'opportunité, vous pouvez leur laisser le sentiment que leurs choix sont limités et ils peuvent commander quelque chose qui ne les satisfait pas.
                        </p>
                        <p class="text-justify" v-tr>
                            To encourage repeat business and cross-selling, customers need to feel good about what they are ordering before they place their order. This requires capturing your customers’ attention, quickly informing your customers with the information you want them to know, while entertaining them at the same time.|
                            Pour encourager la répétition des affaires et la vente croisée, les clients doivent se sentir bien dans ce qu'ils commandent avant de passer leur commande. Cela nécessite de capter l’attention de vos clients, de les informer rapidement des informations que vous souhaitez qu’ils sachent, tout en les divertissant.
                        </p>
                    </b-col>
                    <b-col>
                        <e-img fluid rounded src="img/examples/thai-express-menu.jpg" class="banner" style="max-width: 100%; max-height: 500px;"
                               alt="Thai Express Restaurant MTY Digital Menu Board"></e-img>
                    </b-col>
                </b-row>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" class="mt-5" v-scroll-to="'#services'" variant="light"><span v-tr>Complete suite for Restaurants|Suite complète pour restaurants</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="services" class="page inverted">
            <b-container>
                <h2 class="text-center mb-3" v-tr>6 types of services tailored to Restauration|6 types de services adaptés à la Restauration</h2>

                <b-row>
                    <feature-card src="img/icons/menu.png" alt="Dynamically change and schedule prices with Digital Menu Boards" scroll-to="#menuboard-creation">
                        <h4 v-tr>Digital Menu Boards|Menu numériques</h4>
                        <p v-tr>
                            Design your menu easily. Dynamically change and schedule prices.|
                            Créez votre menu facilement. Modifiez et planifiez vos prix de manière dynamique.
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/videowall.png" alt="Amazing Video Walls" :to="'/digital-signage/videowalls|/affichage-numerique/mur-ecrans-video'|tr">
                        <h4 v-tr>Video Walls|Murs vidéo</h4>
                        <p v-tr>
                            Replace posters and frames with dynamic, interactive and eco-friendly screens.|
                            Remplacez les affiches et les cadres par des écrans dynamiques, interactifs et écologiques.
                        </p>
                    </feature-card>
                    <feature-card src="img/applications/food-force.png" alt="FoodForce Menu Boards"
                                  href="https://thefoodforce.com/business" target="_blank">
                        <h4 v-tr>FoodForce Integration|Intégration FoodForce</h4>
                        <p v-tr>
                            Our Digital Menu Boards are 100% integrated with our FoodForce cloud based solution for self-ordering.|
                            Nos menus numériques sont intégrés à 100% à notre solution basée sur le cloud FoodForce pour la commande automatique.
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/streaming-tv-app.png" alt="Dining and Crew Room TV">
                        <h4 v-tr>Dining and Crew Room TV|Télévision Salle à manger et salle du personel</h4>
                        <p v-tr>
                            Entertain while promoting your own products, not those of your competitors.|
                            Divertissez-vous tout en faisant la promotion de vos propres produits, pas de ceux de vos concurrents.
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/translate.png" alt="Bilingual Digital Menus Boards with Eye-In">
                        <h4 v-tr>Bilingual Menus|Menus bilingues</h4>
                        <p v-tr>
                            Easily create a menu that switches between 2 languages.|
                            Créez facilement un menu qui alterne entre 2 langues.
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/wifi.png" alt="Offer WiFi Network to your guests">
                        <h4 v-tr>WiFi Networks|Réseau WiFi</h4>
                        <p v-tr>
                            Engage your customers on another level using their laptop, cell phone or tablet for additional interactions.|
                            Engagez vos clients à un autre niveau en utilisant leur ordinateur portable, leur téléphone portable ou leur tablette pour des interactions supplémentaires.
                        </p>
                    </feature-card>
                </b-row>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" class="mt-3" v-scroll-to="'#menuboard-creation'" variant="outline-light"><span v-tr>Menu Board Designer|Créer votre menu numérique</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="menuboard-creation" class="page">
            <b-container class="text-center">
                <h3 class="text-center mb-5" v-tr>
                    Design your Menu Board easily|Créez votre menu numérique facilement
                </h3>

                <e-img lazy style="object-fit: contain" width="500" height="300" center rounded class="mb-4" fluid blank-color="#eee"
                       alt="Digital Menu Board Creation with Eye-Infinite Storyboard HTML5"
                       src="img/animations/storyboard-menu-creation.gif"></e-img>
                <br>

                <p v-tr>
                    Thanks to our integration with FoodForce, you can create your Digital Menu Board without efforts.|
                    Grâce à notre intégration avec FoodForce, vous pouvez créer votre menu numérique sans efforts.
                </p>
                <h5 v-tr>
                    All your prices are centralized in one platform to make it easier to manage your restaurants.|
                    Tous vos prix sont centralisés sur une seule plateforme pour faciliter la gestion de vos menus.
                </h5>

                <div class="text-center">
                    <b-btn class="mt-4" :to="'/restauration/menuboard-designer|/restauration/conception-et-design-menus'|tr" variant="primary"><span v-tr>Discover our Menu Designer|Découvrez notre outil de création</span> <i class="fal fa-chevron-right ml-1"></i></b-btn>
                    <br>
                    <b-btn v-if="!isMobileLayout" class="mt-4" v-scroll-to="'#benefits'" variant="light"><span v-tr>Benefits of Digital Menu Boards|Avantages des menus numériques</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="benefits" class="page inverted">
            <b-container>
                <h2 class="text-center mb-5" v-tr>Benefits of Digital Menu Boards|Avantages des menus numériques</h2>

                <b-row>
                    <feature-card src="img/icons/computer.png" alt="Centralised Cloud Digital Signage Content Management">
                        <h4 v-tr>Cloud Management|Gestion centralisé</h4>
                        <p v-tr>
                            Have the absolute freedom to manage your posters remotely as if you were in each store, pushing sales and engaging with the customer.|
                            Ayez la liberté de gérer vos contenus à distance comme si vous étiez dans chaque magasin, pour stimuler les ventes et interagir avec le client.
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/files.png" alt="Digital Dynamic Content">
                        <h4 v-tr>Digital Content|Contenu numérique</h4>
                        <p v-tr>
                            Control all your current traditional paper marketing collateral with a click.|
                            Contrôlez tous vos supports marketing papier traditionnels en un clic.
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/picture.png" alt="Multimedia Content: Images, Videos, Widgets, Weather...">
                        <h4 v-tr>Multimedia|Multimédia</h4>
                        <p v-tr>
                            Alternate between multiple images and videos, intermixing trivia, news headlines, sports scores, local weather forecast, and community involvement all on the same screens.|
                            Alternez entre plusieurs images et vidéos, mélangez des trivia, des résultats sportifs, la météo et la participation communautaire sur les mêmes écrans.
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/calendar-time.png" alt="Schedule your content with our advanced scheduler">
                        <h4 v-tr>Powerful Scheduler|Puissant planificateur</h4>
                        <p v-tr>
                            Have accurate and just in time promotions across all locations.|
                            Proposez des promotions précises et juste à temps sur tous les sites.
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/on-time.png" alt="Entertain and promote your content">
                        <h4 v-tr>Entertain and promote|Divertissez et promouvez</h4>
                        <p v-tr>
                            Reduce perceived waiting time by entertaining while promoting your items.|
                            Réduisez le temps d'attente perçu en divertissant tout en faisant la promotion de vos articles
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/internet.png" alt="Digital Menu Board Database powered">
                        <h4 v-tr>Database Powered|Données centraliséz</h4>
                        <p v-tr>
                            Link your menu to a <b>database</b> to centralize images, description, calories and pricing.|
                            Liez votre menu à une <b>base de données</b> pour centraliser les images, la description, les calories et les prix.
                        </p>
                    </feature-card>
                </b-row>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" class="mt-3" v-scroll-to="'#quick-service-restaurants'" variant="outline-light"><span v-tr>Quick Service Restaurant Example|Exemple pour la restauration rapide</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="quick-service-restaurants" class="page">
            <b-container>
                <h2 class="text-center mb-4" v-tr>Digital Signage for McDonald's|Affichage numérique pour McDonald's</h2>

                <div class="text-center mx-auto" style="max-width: 720px;">
                    <youtube-player iframe-src="https://www.youtube.com/embed/xAQkahG2qeA" :poster="require('../../assets/img/video-splash/overview-mc-donald.jpg')">
                    </youtube-player>
                </div>

                <p class="text-center mt-3" v-tr>
                    Did you know that Eye-In was the first Digital Signage provider for McDonald Canada? Here are examples of work we did for them, including videowall, Digital Menu Boards, TV and Entertainment and much more...|
                    Saviez-vous qu'Eye-In était le premier fournisseur en affichage numérique pour McDonald Canada? Voici des exemples de production réalisées pour eux, incluant des murs vidéos, des menus numériques, l'affichage de loisir et télévision et d'autres encore...
                </p>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" class="mt-4" v-scroll-to="'#optimized-for-tizen'" variant="light"><span v-tr>Optimized with Tizen|Optimisé pour Tizen</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="optimized-for-tizen" class="page inverted">
            <b-container class="text-center">
                <b-img-lazy fluid center width="600" style="object-fit: contain" :src="require('../../assets/img/partners/tizen-digital-signage.png')" alt="Digital Signage Solution optimized for Samsung Tizen"></b-img-lazy>

                <h3 class="mt-4 mb-2" v-tr>
                    All-In-One Digital Menuboards Solution with Samsung Tizen|
                    Solution de menu numérique tout-en-un avec Samsung Tizen
                </h3>
                <h4 v-tr>
                    With Samsung Tizen powered screens and Eye-In Media, Digital Signage becomes so easy. No need to connect a separate Media Player computer to play your content, just plug it into the Internet or use its built-in WiFi.|
                    Avec les écrans alimentés par Samsung Tizen et Eye-In Media, l'affichage numérique devient si simple. Pas besoin de connecter un ordinateur Media Player séparé pour lire votre contenu, il suffit de le brancher sur Internet ou d'utiliser son WiFi intégré.
                </h4>

                <p class="mt-4 presentation" v-tr>
                    Our SaaS Content Management and Creation tools will remotely connect and drive your dynamic content. This seamless integration simplifies the installation, deployment and management of a full-featured digital signage solution.|
                    Nos outils de gestion et de création de contenu SaaS vous connectent directement à votre téléviseur pour afficher votre contenu dynamique. Cette intégration transparente simplifie l'installation, le déploiement et la gestion de notre solution d'affichage numérique complète.
                </p>

                <p class="mt-4 presentation" v-tr>
                    Works in both one-screen environments as well as multi-screen and multi-location environments.|
                    Fonctionne aussi bien dans un environnement avec un seul écran que dans les environnements multi-écrans et plusieurs emplacements.
                </p>

                <e-img lazy fluid center width="256" style="object-fit: contain" src="img/partners/eyein-partner-samsung.png" alt="Media Player for Digital Signage built for Samsung Tizen"></e-img>

                <div class="">
                    <b-btn v-if="!isMobileLayout" class="mt-3" v-scroll-to="'#why-chose-eyein'" variant="outline-light"><span v-tr>Why chose us|Pourquoi nous choisir</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="why-chose-eyein" class="page inverted">
            <b-container>
                <h2 class="text-center mb-5" v-tr>
                    Why choose Eye-In for your Digital Menu Board?|
                    Pourquoi choisir Eye-In pour votre menu numérique?
                </h2>

                <b-row>
                    <feature-card src="img/icons/shop.png" :to="'/digital-signage/services|/affichage-numerique/services'|tr" alt="Turnkey Solution">
                        <h4 v-tr>Turnkey Solution|Solution clé en main</h4>
                        <p v-tr>
                            Installation, configuration, content creation, support, mobile applications...|
                            Installation, configuration, création de contenu, support, applications mobiles ...
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/call-center.png" :to="'/digital-signage/services|/affichage-numerique/services'|tr" alt="Excellent Customer Support">
                        <h4 v-tr>Excellent customer support|Excellent support technique</h4>
                        <p v-tr>
                            Client satisfaction is the most important at Eye-In Media|
                            La satisfaction de nos clients est une de nos priorité
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/thumb-up.png" :to="'/digital-signage/storyboard/infinite|/affichage-numerique/storyboard/infinite'|tr" alt="No graphics designer required">
                        <h4 v-tr>No specialist required|Aucun spécialiste requis</h4>
                        <p v-tr>
                            No programmer or graphic designer required even to integrate external feeds (ex trivia, RSS feeds, traffic, weather)|
                            Aucun programmeur ou graphiste requis même pour intégrer des flux externes (ex trivia, flux RSS, trafic et météo)
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/tv.png" alt="No screen or storage limits">
                        <h4 v-tr>No Restrictions|Aucune limite</h4>
                        <p v-tr>
                            There is no limit for the number of screens or storage|
                            Il n'y a pas de limite pour le nombre d'écrans ou de stockage
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/code.png" alt="Eye-In always invest in Research & Development">
                        <h4 v-tr>Constant R&D|R&D continue</h4>
                        <p v-tr>
                            Our software is always evolving with improved features and functionalities|
                            Notre logiciel évolue constamment avec des nouvelles fonctions et des améliorations
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/qr-code.png" alt="Easily create and print QR codes for menu boards">
                        <h4 v-tr>QR Codes|Codes QR</h4>
                        <p v-tr>
                            Generate <b>QR Codes</b> for your content directly within the application|
                            Générez des <b>codes QR</b> pour votre contenu directement dans l'application
                        </p>
                    </feature-card>
                </b-row>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" class="mt-3" v-scroll-to="'#clients'" variant="outline-light"><span v-tr>Our Clients|Nos clients</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="clients" class="page">
            <b-container>
                <h3 class="text-center" v-tr>They chose us|Ils nous ont choisis</h3>
                <signage-restauration-client-cards></signage-restauration-client-cards>

                <div class="text-center">
                    <router-link class="mt-3" :to="'/digital-signage/clients|/affichage-numerique/clients'|tr" variant="primary"><span v-tr>All our clients and markets|Tous nos clients et marchés</span> <i class="fal fa-chevron-right ml-1"></i></router-link>
                    <br>
                    <b-btn v-if="!isMobileLayout" class="mt-5" v-scroll-to="'#contact-us'" variant="light"><span v-tr>Contact Us|Nous contacter</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>
    </website-page>
</template>

<script>
    import SignageRestaurationClientCards from "@/client-cards/signage-restauration-client-cards.vue";
    import RestaurationNavigation from "@/navigation/restauration-navigation.vue";
    import {translate} from "../../../vue-components/helpers/i18n.js";

    export default {
        name: `digital-signage-for-restaurants`,
        components: {RestaurationNavigation, SignageRestaurationClientCards},
        metaInfo: {
            title: translate(`A Complete Solution for Restaurant Digital Signage|Une solution d'affichage numérique complète pour restaurants`),
            meta: [
                { name: `keywords`, content: `menu board, menuboard, digital, signage, restaurants, bars, fast-foods, menus, dynamic, smart, schedule, advertising` },
                { name: `description`, content: translate(`Go 100% Cloud with Eye-In Digital Menu Boards|Partez 100% Cloud avec l'affichage numérique Eye-In`) }
            ]
        }
    }
</script>

<style lang="scss" scoped>
    .main-section {
        background-color: #151e28;
        //background-image: url('../../assets/img/backgrounds/menu-board-thai-express.jpg');
        background-size: cover;
    }

    #optimized-for-tizen {
        background-image: url('../../assets/img/backgrounds/tizen-desktop.jpg') !important;
        background-image: url('../../assets/img/backgrounds/tizen-desktop.webp') !important;
        background-size: cover !important;
        background-position: center center !important;

        @media(max-width: 576px) {
            background-image: url('../../assets/img/backgrounds/tizen-mobile.jpg') !important;
            background-image: url('../../assets/img/backgrounds/tizen-mobile.webp') !important;
        }
    }
</style>
